import { forwardRef, useRef } from 'react';
import { Platform } from 'react-native';
import { WebView } from 'react-native-webview';

import { HStack, Text, VStack, theme } from '@squire/ui';

import type { BottomSheetRef } from '@/components/_shared/BottomSheet';
import { BottomSheet } from '@/components/_shared/BottomSheet';
import { CloseButton } from '@/components/_shared/CloseButton';
import { config } from '@/constants/config';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';
import composeRefs from '@/utils/composeRefs';

import { styles } from './styles';
import type { TermsWebViewModalProps, TermsWebViewModalRef } from './types';

const webIFrameStyle = { height: '100%', width: '100%' };

const TermsWebViewModal = forwardRef<
  TermsWebViewModalRef,
  TermsWebViewModalProps
>((props, ref) => {
  const { t } = useScreenTranslations('TermsWebViewModal');
  const innerRef = useRef<BottomSheetRef>(null);

  return (
    <>
      <BottomSheet
        ref={composeRefs(ref, innerRef)}
        snapPoints={[{ percentage: '90%' }]}
        style={styles.bottomSheet}
        {...props}
      >
        <VStack flex space={theme.spacing[5]}>
          <HStack style={styles.header}>
            <Text variant="2xlStrong">{t('title')}</Text>

            <CloseButton
              onPress={() => innerRef.current?.close()}
              accessibilityLabel={t('accessibility.closeButton')}
              accessibilityHint={t('accessibility.closeButtonHint')}
            />
          </HStack>

          {Platform.OS === 'web' ? (
            <iframe src={config.termsUrl} style={webIFrameStyle} />
          ) : (
            <WebView source={{ uri: config.termsUrl }} />
          )}
        </VStack>
      </BottomSheet>
    </>
  );
});

TermsWebViewModal.displayName = 'TermsWebViewModal';
export { TermsWebViewModal };
